export default __webpack_public_path__ + "static/media/add_liquidity.7ab32b29.png";